import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { StorageService } from 'src/app/Services/storage.service';
import { LoaderService } from "src/app/Services/loader.service";

@Component({
  selector: 'app-head-reports',
  templateUrl: './head-reports.component.html',
  styleUrls: ['./head-reports.component.css']
})
export class HeadReportsComponent implements OnInit {


  constructor(
    private dateAdapter: DateAdapter<Date>,
    public api: ApiService,
    public com: CommonServices,    
    public storage: StorageService,
    public loader: LoaderService,
    public excel: ExcelExportService
  ) {
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
  }

  ngOnInit(): void {
    this.filterFormsLoad();
    this.headCountAPI({
      tripDate: new Date(new Date(this.filterFormGrp.value.tripDate).setHours(0, 0, 0, 0)).getTime()
    })
    this.getListShift();
  }

  public filterFormGrp: FormGroup;
  public tableHeaders: any = ['#', 'Shift time', 'Transit mode', 'Male', 'Female', 'Total'];
  public tableData: any = [];
  public matFormSize: string = '13px';
  public vehWiseObj: any = [];
  public getTranMode: any = '';
  public noDataFoundEnable: boolean = false;
  public filteredData:any=[];
  public resData:any= [];
  public vehTypeCount:any={};
  public vehType:any=[];
  public gettime: any = '';
  public shiftListArr: any = [];
  public getBranchListArr:any=[];
  public showTable: boolean = true;
  public responseData:any = [];
  public convertedTime:any = '';
  public currentYear = new Date().getFullYear();
  public minDate = new Date(this.currentYear - 1, 0, 1);
  public maxDate = new Date(this.currentYear, 11, 31);
  // Excel Variabels
  public excelData: any = [];

  filterFormsLoad() {
    this.filterFormGrp = new FormGroup({
      tripDate: new FormControl(new Date),
      transitMode: new FormControl(''),
      shiftTimeStr: new FormControl(''),
    })
  }

  fieldChange(e: any, fieldType) {
    this.convertedTime= ''
    let value = e.value;
    if (fieldType == 'transitMode') {
      this.getTranMode = value;
    }  
    if (fieldType == 'shiftTimeStr') {
      this.gettime = value;
      this.convertTime12to24(this.gettime)
    }
  }
  
  convertTime12to24(time12h){
    const [time, modifier] = time12h.split(" ");
    let [hours, minutes] = time.split(":");
      if (hours === "12") {
          hours = "00";
      }
      if (modifier === "PM") {
          hours = parseInt(hours, 10) + 12;
      }
      this.convertedTime = `${hours}:${minutes}`
      return this.convertedTime;
  }

  headCountAPI(obj) {
    this.tableData = [];
    this.shiftListArr = [];
    this.api.getHeadCountReports(obj).then((res: any) => {
      if (res && res['status'] && res['status'] == 'success') {
        if (res && res['data'] && res['data'].length > 0) {
          this.resData = res['data'][0];
          if(Object.keys(this.resData).length < 0){
            this.loader.show()
          }else{
            this.loader.hide()
          }
          if (this.tableData.length <= 0) {
            this.noDataFoundEnable = true
          }
          this.changeTheObjToVehWise()
          this.getShitTimeOnly(this.filteredData);
        } else {
          this.tableData = [];
          this.noDataFoundEnable = true;
        }
      } else {
        this.tableData = [];
        this.noDataFoundEnable = true;
      }
    }).catch((err) => {
      console.log(err);
    })
    
  }


  getListShift() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.ListShift(obj).then((res: any) => {
      if (res && res.status && res.status == 'success') {
        if (res && res['data'] && res['data'].length > 0) {
          let resData = res['data'];
          for(let b=0;b<resData.length ;b++){
            let obj={}
            obj['endTime']=resData[b]['endTime'];
            obj['startTime']=resData[b]['startTime'];
            obj['shiftName']=resData[b]['shiftName'];
            this.getBranchListArr.push(obj)
          }
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  onSubmit() {
    let obj = {}
    if (obj['tripDate'] != '') obj['tripDate'] = new Date(new Date(this.filterFormGrp.value.tripDate).setHours(0, 0, 0, 0)).getTime()
    if (this.filterFormGrp.valid) {
      this.headCountAPI(obj)
    }
  }

  changeTheObjToVehWise() {
    this.vehTypeCount ={};
    this.vehType=[];
    this.filteredData = [];
    let obj = this.resData
    let transitModes = Object.keys(obj)

    if (transitModes.length > 0) {
      let finalValue ={}
      for (let i = 0; i < transitModes.length; i++) {
        let transitMode = transitModes[i];
       
        if(finalValue[transitMode] == undefined) finalValue[transitMode] = {}
       
        let shiftTimes = Object.keys(obj[transitModes[i]])
        for (let j = 0; j < shiftTimes.length; j++) {
        let shiftTime = shiftTimes[j]
        if(finalValue[transitMode][shiftTime] == undefined) finalValue[transitMode][shiftTime] = {}

          let vehRegNumbers = Object.keys(obj[transitModes[i]][shiftTimes[j]])
          for (let k = 0; k < vehRegNumbers.length; k++) {
            let types = obj[transitModes[i]][shiftTimes[j]][vehRegNumbers[k]]
            let finalObj = {
              male: 0,
              female: 0,
              total: 0
            }
            finalObj['type'] = types['type'];
            finalObj['shiftTimeStr'] = shiftTimes[j];
            finalObj['transitMode'] = transitModes[i];

            if (types['scheduled'] && Object.keys(types['scheduled']).length > 0) {
              finalObj['male'] += types['scheduled']['m'];
              finalObj['female'] += types['scheduled']['f'];
            }
            if(finalValue[transitMode][shiftTime]['male'] == undefined)finalValue[transitMode][shiftTime]['male'] = 0
            if(finalObj['male']){
              finalValue[transitMode][shiftTime]['male'] = finalValue[transitMode][shiftTime]['male'] + finalObj['male']
            }
            if(finalValue[transitMode][shiftTime]['female'] == undefined)finalValue[transitMode][shiftTime]['female'] = 0
            if(finalObj['female']){
              finalValue[transitMode][shiftTime]['female']= finalValue[transitMode][shiftTime]['female'] + finalObj['female']
            }
            if(finalValue[transitMode][shiftTime]['total'] == undefined)finalValue[transitMode][shiftTime]['total'] = 0
            finalValue[transitMode][shiftTime]['total'] = finalValue[transitMode][shiftTime]['male'] + finalValue[transitMode][shiftTime]['female']

            finalObj['total'] = finalObj['male'] + finalObj['female']
              
              let index =  this.vehType.findIndex((item)=>item==types['type'])
              if(index ==-1) this.vehType.push(types['type'])

              if(this.vehTypeCount[transitModes[i]] == undefined) this.vehTypeCount[transitModes[i]] = {}
              if(this.vehTypeCount[transitModes[i]][shiftTimes[j]] == undefined) this.vehTypeCount[transitModes[i]][shiftTimes[j]] = {}
              if( this.vehTypeCount[transitModes[i]][shiftTimes[j]][types['type']] == undefined ) this.vehTypeCount[transitModes[i]][shiftTimes[j]][types['type']] = 1
              else{
                this.vehTypeCount[transitModes[i]][shiftTimes[j]][types['type']]++
              }

          }
        }
      }
      Object.keys(finalValue).map((trasitMode:any)=>{
        Object.keys(finalValue[trasitMode]).map((shift:any)=>{
          let obj = {...finalValue[trasitMode][shift]}
          obj['transitMode'] = trasitMode;
          obj['shiftTimeStr'] =shift;
          this.tableData.push(obj)
          this.filteredData.push(obj)
        })
      })
      this.responseData = this.filteredData;
    }
    // Filter Functionality Area
    if(this.gettime && this.filterFormGrp.value.transitMode == ''){
      let arr =  this.gettime.split('-') //['4:00 PM','10:00 AM']
      if(arr.length>0){
        arr = arr.map((item:any)=>{
          item = this.convertTime12to24(item);
          return item;
        })
     
        let obj ={}
          obj['Pickup'] = arr[0]
          obj['Drop'] = arr[1]
    
        let finalArr =[];
        for(let i=0;i<this.filteredData.length ;i++){
          let time = this.filteredData[i];
          Object.keys(obj).map((modes:any)=>{
            if(modes == time['transitMode']){
              if(time && time['shiftTimeStr'] && time['transitMode']){
                if(obj[modes] == time['shiftTimeStr']){
                  finalArr.push(time);
                }
              }
            }
          })
        }
        this.filteredData = finalArr;
      }
    }
        
    if (this.gettime != '' && (this.filterFormGrp.value.transitMode == 'Pickup' || this.filterFormGrp.value.transitMode == 'Drop')) {
      this.filteredData = this.filteredData.filter(e => e['shiftTimeStr'] == this.convertedTime)
    }
    if (this.getTranMode != '') {
      this.filteredData = this.filteredData.filter(e => e['transitMode'] == this.getTranMode)
    }
  }

  getShitTimeOnly(obj: any) {
    let shiftArr = [];
    obj.map((shift: any) => {
      shiftArr.push(shift['shiftTimeStr'])
    })
    if(shiftArr.length > 0){
      this.shiftListArr = this.removeDuplicates(shiftArr);
    }
  }
  removeDuplicates(arr) {
    return arr.filter((item, index) => arr.indexOf(item) === index);
  }

  resetFilterForm(){
    this.gettime = '';
    this.getTranMode = '';
    this.filterFormGrp.patchValue({
      tripDate:new Date(),
      transitMode: '',
      shiftTimeStr: ''
    })
    this.headCountAPI({
      tripDate: new Date(new Date(this.filterFormGrp.value.tripDate).setHours(0, 0, 0, 0)).getTime()
    })  
    this.fieldChange({'value':''},'transitMode')
  }

  // Excel download 
  public letters=['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
  async exportToExcel() {
    this.excelData = {};
    let data = [];
    let excelHeader = ['S No', 'Shift time', 'Transit mode', 'Male', 'Female', 'Total'];
    for (let i = 0; i < this.filteredData.length; i++) {
      let item = this.filteredData[i];
      try {
          let value = [
            i + 1,
            item.shiftTimeStr ? item.shiftTimeStr : '---',
            item.transitMode ? item.transitMode : '---',
            item.male ? item.male : 0,
            item.female ? item.female : 0,
            item.total ? item.total : 0,
          ];
          // for(let j=0;j< this.vehType.length; j++){
          //   let type = this.vehType[j];
          //   let count = 0;
          //   if(this.vehTypeCount[item.transitMode] && this.vehTypeCount[item.transitMode][item.shiftTimeStr] 
          //         && this.vehTypeCount[item.transitMode][item.shiftTimeStr][type]) count = this.vehTypeCount[item.transitMode][item.shiftTimeStr][type]
          //       value.push(count)
          // }
        let res = {
          value: value,
          border: { right: { style: 'thin' }, bottom: { style: 'thin' } },
        }
        data.push(res);
      } catch (err) {
        console.log(err);
      }
    }
    if (data.length > 0) {
      let rowCount = 2;
      let endCell = this.letters[excelHeader.length-1];
      let customizedData = [];
      let titleRow = {
        value: ['Shift Wise Report'],
        font: {
          name: 'Corbel', family: 4, size: 16, bold: true,
          color: { argb: 'FFFFFFFF' },
        },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
        alignment: {
          cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '966462AF' },
          bgColor: { argb: 'FFF' }
        },
      }
      customizedData.push(titleRow);

      rowCount = rowCount + 2;

      let subtitleRow = {
        value: [
          "Trip Date          : " + this.com.timestampToDate(new Date(this.filterFormGrp.value.tripDate).getTime(), 'DMY') + "\n"
        ],
        font: { name: 'Corbel', family: 4, size: 12, },
        border: { right: { style: 'thin' } },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      }

      customizedData.push(subtitleRow);

      rowCount = rowCount + 1;
      let headerRow =
      {
        value: [...excelHeader],
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
      }
      customizedData.push(headerRow);

      customizedData.push(...data);
      let excelSheetName = 'Shift Wise Report';
      if (this.excelData[excelSheetName] == undefined) { this.excelData[excelSheetName] = {}; }

      this.excelData[excelSheetName] = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 2, width: 15 }, { colNo: 3, width: 15 }, { colNo: 4, width: 10 }, { colNo: 5, width: 10 }, { colNo: 6, width: 10 }, { colNo: 7, width: 10 }, { colNo: 8, width: 10 }, { colNo: 9, width: 15 }]
        }
      };// excelInfo;
      this.downloadExlReport();
    }
  }
  downloadExlReport() {
    this.excel.generateExcel(this.excelData, 'Shift Wise Report_' + " "+this.com.timestampToDate(new Date().getTime(), 'DMY') + ' '  + '.xlsx');
  }
}
